import { useGraphQuery } from '@/hooks/useGraphQuery';
import { TreeNode } from '@/types';

export interface UseSeedProvenanceQueryResult {
  data: TreeNode[] | undefined;
  isLoading: boolean;
  status: 'pending' | 'error' | 'success';
}

export function useSeedProvenanceQuery(
  seedKey: string
): UseSeedProvenanceQueryResult & { refetch: () => void } {
  const { data, isLoading, status, refetch } = useGraphQuery({
    tree: true,
    query: {
      node: {
        relationships: [
          {
            label: 'DISCOVERED',
            length: 3,
            target: {
              labels: ['Seed'],
              filters: [
                {
                  field: 'key',
                  operator: '=',
                  value: seedKey,
                },
              ],
            },
          },
        ],
      },
    },
    enabled: Boolean(seedKey),
  });

  return { data, isLoading, status, refetch };
}
